/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DOWNVOTE_DESC" | "REPLIES_DESC" | "UPVOTE_DESC" | "%future added value";
declare const _AllCommentsTabContainerLocal$ref: unique symbol;
export type AllCommentsTabContainerLocal$ref = typeof _AllCommentsTabContainerLocal$ref;
export type AllCommentsTabContainerLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": AllCommentsTabContainerLocal$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AllCommentsTabContainerLocal",
    "type": "Local",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "commentsOrderBy",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '164d2a720a8d0cd686a9e3d34832dfa0';
export default node;
